// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3kbHr","location":"Header_location__QXsR1"};